export default function () {
  return {
    tickets: [],
    ticket: {},
    chats: [],
    attachments: []
  }
}
